module.exports = __webpack_public_path__ + "img/greyf2f.08f9d293.svg";